declare namespace $ {

	export class $shm_hitalama_tabulator extends $mol_view {
		dom_name( ): string
		columns( ): readonly(any)[]
		data( ): readonly(any)[]
		options( ): any
		sub( ): any
	}
	
}

//# sourceMappingURL=tabulator.view.tree.d.ts.map